export default "__VITE_ASSET__B_QOkvQo__"